<template>
  <div class="Footer">
    <footer>
      <!-- Bloque Social -->
      <div class="social py-3">
        <ul class="list-unstyled d-flex justify-content-center gap-3 mb-0">
          <li>
            <a :href="configData.general.SocialNetworks.facebook" target="_blank" rel="noopener" class="text-decoration-none">
              <i class="fa fa-facebook"></i>
            </a>
          </li>
          <li>
            <a :href="configData.general.SocialNetworks.instagram" target="_blank" rel="noopener" class="text-decoration-none">
              <i class="fa fa-instagram"></i>
            </a>
          </li>
          <li>
            <a :href="configData.general.SocialNetworks.youtube" target="_blank" rel="noopener" class="text-decoration-none">
              <i class="fa fa-youtube-play"></i>
            </a>
          </li>
        </ul>
      </div>

      <!-- Bloque gris -->
      <div class="fondo-gris py-4">
        <div class="container">
          <div class="row g-4 enlaces-rapidos">
            <!-- Col 1 -->
            <div class="col-md-4">
              <div class="logo-iff mb-3">
                <img :alt="configData.general.brandName" src="@/assets/logo-iff.png" />
              </div>
              <div class="resumen">
                {{ configData.general.brandSubject }}
              </div>
            </div>

            <!-- Col 2 -->
            <div class="col-md-4">
              <h4 class="mb-3"><strong>ENLACES RÁPIDOS</strong></h4>
              <ul class="list-unstyled m-0 text-start">
                <li v-for="section in section_list" :key="section.url_es" class="mb-2">
                  <router-link :to="'/' + section.url_es" class="text-decoration-none">
                    <span>{{ section.name_sec_es }}</span>
                  </router-link>
                </li>
              </ul>
            </div>

            <!-- Col 3 -->
            <div class="col-md-4">
              <ul class="list-unstyled m-0">
                <li v-if="configData.general.isLoggingAvailable" class="mb-2">
                  <a href="#" class="acceso d-inline-flex align-items-center"
                     data-bs-toggle="modal" data-bs-target="#myModal2">
                    <span class="material-icons-outlined me-2">vpn_key</span> Iniciar Sesión
                  </a>
                </li>
                <li v-if="configData.general.isLoggingAvailable" class="mb-2">
                  <router-link :to="'/registrar'" class="acceso d-inline-flex align-items-center">
                    <span class="material-icons-outlined me-2">account_circle</span> Mi Cuenta
                  </router-link>
                </li>
                <li v-if="configData.general.isEcommercePage" class="mb-2">
                  <router-link :to="'/carrito'" class="acceso d-inline-flex align-items-center">
                    <span class="material-icons-outlined me-2">shopping_cart</span> Mi Carrito
                  </router-link>
                </li>
                <li class="mb-2">
                  <a :href="configData.general.corporateWebPage" class="acceso d-inline-flex align-items-center">
                    <span class="material-icons-outlined me-2">business</span>
                    {{ configData.general.brandName }}
                  </a>
                </li>
                <li class="img-libro-reclamaciones">
                  <router-link :to="'/reclamo'" class="acceso link-libro-reclamaciones"></router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Bloque azul -->
      <div class="fondo-azul text-white py-3">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-6 text-center text-md-start mb-2 mb-md-0">
              © {{ getActualYear() + ' ' + configData.general.brandShortName }}. Todos los derechos reservados.
            </div>
            <div class="col-md-6 d-flex justify-content-center justify-content-md-end align-items-center gap-2">
              <span>Desarrollado por:</span>
              <a :href="'http://' + configData.general.developerCorporateWebPage" class="d-inline-flex align-items-center">
                <img src="@/assets/analysofti-logo.png" :alt="configData.general.developerName" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import data from '@/staticData.json';

export default {
  name: 'Footer',
  props: ['section_list'],
  data() {
    return {
      configData: data,
    };
  },
  methods: {
    getActualYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="scss" src="./Footer.scss"></style>
